module.exports = __webpack_public_path__ + "img/wallet-consumption.3a0d07a4.svg";